<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="8">功能选择</el-col>
      <el-col :span="16"style="text-align: center;width: 40%;">目标词K列表</el-col>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-row  class="tui-el">
        <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"

              :value="item.value">
            </el-option>

          </el-select>
          <input type="text" v-model="search" @change="onChangeStripe()" style="height: 32px;"/>
        </el-row>

          <el-row  class="tui-el" style="margin-top: 10px;">
            <input type="text" v-model="ciku" style="height: 32px;"/>

            <input type="button"   @click="addciku()" style="height: 32px;margin-left: 40px;" value="添加词库">
          </el-row>
          <el-row  class="tui-el" style="margin-top: 10px;">
            <el-col :span="24" style="border: 1px solid #c6c6c6;height: 650px;overflow-y:scroll;width: 90%;">
               <el-row  class="tui-el" v-for="(item,index) in listci" :key="index">
                 <el-col :span="20" style="text-align: center;line-height: 60px;">{{item.cname}}</el-col>

                 <el-col :span="4" style="text-align: center;line-height: 60px;" @click.native="delci(item.cname,item.lid)">删除</el-col>
               </el-row>
            </el-col>
          </el-row>
      </el-col>

      <el-col :span="16" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 40%;">


        <el-row  class="tui-el">
          <el-col :span="8" style="text-align: center;">目标词</el-col>
          <el-col :span="8" style="text-align: center;">方位</el-col>
          <el-col :span="4" style="text-align: center;">词库</el-col>
          <el-col :span="4" style="text-align: center;">操作</el-col>
        </el-row>
        <el-row  class="tui-el">
          <el-col :span="8" style="text-align: center;line-height: 60px;"><input type="text" style="height: 32px;" v-model="newName"></el-col>
          <el-col :span="8" style="text-align: center;line-height: 60px;">
            <el-select v-model="values"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in types"
                  :key="item.name"
                  :label="item.name"

                  :value="item.id">
                </el-option>
              </el-select>
          </el-col>
          <el-col :span="8" style="text-align: center;margin-top: 20px;"><input type="button"   @click="add()" value="添加"></el-col>
        </el-row>
        <el-row  class="tui-el" v-for="(item,index) in list" :key="index">
          <el-col :span="8" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>
          <el-col :span="8" style="text-align: center;line-height: 60px;">{{item.namek}}</el-col>
          <el-col :span="4" style="text-align: center;line-height: 60px;">{{item.cname}}</el-col>
          <el-col :span="4" style="text-align: center;margin-top: 20px;" @click.native="del(item.id,index)">删除</el-col>
        </el-row>
        <div class="page">
        	<el-pagination
        	  @size-change="loadList()"
        	  @current-change="loadList()"
        	  :current-page.sync="page"
        	  :page-size="50"
        	  background
        	  layout="total,prev, pager, next, jumper"
        	  :total="count">
        	</el-pagination>
        </div>
      </el-col>


    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleci"
      width="30%"
      >
      <span>确认删除该组？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibleci = false">取 消</el-button>
    	<el-button type="primary" @click="dociDell()">确 定</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [],
        types:[{'id':1,'name':'左'},{'id':2,'name':'右'},{'id':3,'name':'左右'}],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: '',
        values:3,
        newName:'',
        imageId: 0,
        list: [],
        search:'',
        page:1,
        ciku:'',
        listci:[],
        dialogVisibleci:false,
        cilid:0,
        ciname:''

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{
    delci(name,lid){
      this.dialogVisibleci = true
      this.cilid = lid
      this.ciname = name

    },
    dociDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.cilid == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		lid:this.cilid,
          name:this.ciname,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonMubiaokListDelcin'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.cilid = 0
           this.dialogVisibleci = false
           this.ciname = ''
           this.loadListci()
           this.loadList()
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisibleci = false
      	}

      })
      .catch(err=>{

      });
    },
    loadListci(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          p:this.page,
          l_id:this.value,
          name:this.search
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/muBiaokListcin'
      })
      .then(res=>{
      	this.listci = res.data;

      })
      .catch(err=>{

      });
    },
    addciku(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.ciku == ''){
        this.msg('请填写名称','error')
        return false
      }
      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/cikuListAddn',
      	params:{
      		name:this.ciku,
          l_id:this.value,
          t:3
      	}
      })
      .then(res=>{
        if(res.data.code == 200){
          this.tableData = res.data.data
          this.newName = ''
          this.loadList()
        }else{
          alert('词汇重复')
        }

      })
      .catch(err=>{

      });
    },
    UploadUrl(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythonImgChange?id="+id
    },
    onChangeStripe(){
      this.loadList()
      this.loadListci()
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']
        this.loadList()
    	})
    	.catch(err=>{

    	});
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          p:this.page,
          l_id:this.value,
          name:this.search
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/muBiaoKListn'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },

    ceshi(index){
      this.imageId = index
    },
    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonMubiaoKListDeln'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }

      console.log(this.addImgs)
      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonMubiaoKListAddn',
      	params:{
      		name:this.newName,
          l_id:this.value,
          type:this.values
      	}
      })
      .then(res=>{

        if(res.data.code == 200){
          this.tableData = res.data.data
          this.newName = ''
          this.loadList()
        }else{
          alert('词汇重复')
        }
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/nmubiaok.vue